import { TEAM_ROSTER_SIZE, getActiveRosterSize } from '../constants';

export type ValidationResult = {
  valid: boolean;
  type: 'warning' | 'error' | null;
  message: string[];
};

type SectionCount = {
  label: string;
  count: number;
};

export function ValidateTeam(
  fortyManRosterSize: number,
  activeRosterSize?: number | null,
  minorLeagueSectionCounts: SectionCount[] = []
): ValidationResult {
  let valid = true;
  let type: 'warning' | 'error' | null = null;
  const message: string[] = [];

  // Active roster (26 / Sep–Oct 28) check
  const activeLimit = getActiveRosterSize();
  if (activeRosterSize != null && activeRosterSize > activeLimit) {
    valid = false;
    if (!type) type = 'warning';
    message.push(
      `You have ${activeRosterSize} players on your active roster (maximum ${activeLimit} for the current period).`
    );
  }

  // 40-man roster size check
  if (fortyManRosterSize > TEAM_ROSTER_SIZE) {
    valid = false;
    if (!type) type = 'warning';
    message.push(`You have ${fortyManRosterSize} players on your ${TEAM_ROSTER_SIZE} man roster.`);
  }

  // Minor league section size checks (AAA and below)
  const MINOR_SECTION_LIMIT = 30;
  minorLeagueSectionCounts.forEach(({ label, count }) => {
    if (count > MINOR_SECTION_LIMIT) {
      valid = false;
      if (!type) type = 'warning';
      message.push(
        `You have ${count} players in ${label} (maximum ${MINOR_SECTION_LIMIT}).`
      );
    }
  });

  return { valid, type, message };
} 